<template>
  <section class="product-suggest" v-if="(showWhileLoading && loading) || loaded" :class="{ 'product-suggest--tabled': !isCondensed, 'serial-compare--loading': loading, 'deals-bold': boldDeals, 'collapse': items.length < minRequired }">
    <template v-if="items.length && (items.length >= minRequired)">
      <div class="t-h2" v-if="name == 'similar'" v-html="similarTitle"></div>
      <slot></slot>
      <div class="product-suggest__stage" :class="{ 'hide-visual': homepageTrending }">
        <div :is="itemsListTag" class="product-suggest__items" ref="scroller" :class="{ 'paged': isPaged && paginated }">
          <template v-if="specs.length && !isOos">
            <table class="product-suggest__table" :id="`product-suggest-table-${itemid}`" role="table" aria-label="Product comparison">
              <caption class="visually-hidden">Product comparison: specifications by product</caption>
              <thead>
                <tr>
                  <td>
                    <div class="checkboxContainer">
                      <label class="highlightDifferencesLabel">
                        <input type="checkbox" class="highlightDiffCheckbox" :id="`highlightDifferences-${itemid}`" name="highlightDifferences" data-log="highlight differences" @click="highlightDifferences()">
                        Highlight Differences
                      </label>
                    </div>
                  </td>
                  <th v-for="item in items" :id="colHeaderId(item)" scope="col" :class="item.itemid == itemid ? 'current' : null">
                    <span class="visually-hidden">{{ columnHeaderLabel(item) }}</span>
                    <item :item="item" :current="item.itemid === itemid" :is-compare-item="true" :logging-action="loggingAction" :show-more-details-button="showMoreDetailsButton" :show-free-shipping-msg="showFreeShippingMsg" :feed-identifier="feedIdentifier" :show-badge-chips="showBadgeChips" :inlinereviewnum="inlinereviewnum" tag="div">
                    </item>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(spec, specIndex) in specs" :key="specIndex" :class="'row' + spec.name.replace(/\s/g, '')">
                  <th :id="rowHeaderId(specIndex)" scope="row">
                    {{ spec.name }}
                  </th>
                  <td v-for="item, index in items" :key="index" :class="item.itemid == itemid ? 'current' : 'column' + index">
                    <span class="visually-hidden">for {{ columnHeaderLabel(item) }}:&nbsp;</span>
                    <span v-if="spec.values[item.itemid] !== '-'">{{ spec.values[item.itemid] }}</span>
                    <span v-else aria-label="No value for this specification">
                      <span aria-hidden="true">-</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <template v-for="item, index in items">
              <item v-if="item.itemid !== itemid" :item="item" :key="index" :data-gridindex="index" :data-itemid="item.itemid" :logging-action="loggingAction" v-show="isCondensed" :show-add-to-cart-button="showAddToCartButton" :show-more-details-button="showMoreDetailsButton" :show-financing="showFinancing" :show-specials="showSpecials" :add-to-cart-button-text="addToCartButtonText" :show-in-stock-notice="showInStockNotice" :show-product-callout="showProductCallout" :show-bundle-savings="showBundleSavings" :show-free-shipping-msg="showFreeShippingMsg" :show-certified-fit-cases="showCertifiedFitCases" :slider-has-star-ratings="sliderHasStarRatings" :slider-has-promos="sliderHasPromos" :inlinereviewnum="inlinereviewnum" :is-category-feed="isCategoryFeed" :feed-identifier="feedIdentifier" :show-badge-chips="showBadgeChips" :badge-override-text="badgeOverrideText" :badge-override-class="badgeOverrideClass" v-on:addToCart="addToCart" v-on:itemClicked="itemClicked">
              </item>
            </template>
          </template>
        </div>
        <div class="product-suggest__nav product-suggest__nav--prev" :class="{ 'disabled': !canScrollPrev, 'visible': isPaged && paginated }" @click.prevent="scroll(0)" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
            <g fill="none" stroke="#000" stroke-linecap="round" stroke-width="2">
              <g>
                <circle cx="20" cy="20" r="20" stroke="none" />
                <circle cx="20" cy="20" r="19" fill="none" />
              </g>
              <path d="M22.238 12.495l-7.739 7.739 7.739 7.739" fill="none" />
            </g>
          </svg>
          Previous
        </div>
        <div class="product-suggest__nav product-suggest__nav--next" :class="{ 'disabled': !canScrollNext, 'visible': isPaged && paginated }" @click.prevent="scroll(1)" aria-hidden="true">
          Next
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
            <g fill="none" stroke="#000" stroke-linecap="round" stroke-width="2">
              <g transform="rotate(180 20 20)">
                <circle cx="20" cy="20" r="20" stroke="none" />
                <circle cx="20" cy="20" r="19" fill="none" />
              </g>
              <path d="M17.762 27.505l7.739-7.739-7.739-7.739" fill="none" />
            </g>
          </svg>
        </div>
      </div>
      <slot name="footer">
        <div v-if="!loading && parsedFeedCta && parsedFeedCta.active" class="product-suggest__button-wrap slider-cta">
          <a :href="parsedFeedCta.url" class="btn cta-btn" v-html="parsedFeedCta.text">
          </a>
        </div>
      </slot>
    </template>
    <svg v-else-if="showWhileLoading && loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="48px" height="48px" class="product-suggest__loader">
      <rect x="0" y="0" width="100" height="100" fill="#ffffff " class="bk"></rect>
      <g transform="translate(20 50)">
        <rect x="-10" y="-30" width="20" height="60" fill="#aaaaaa " opacity="0.6">
          <animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform>
        </rect>
      </g>
      <g transform="translate(50 50)">
        <rect x="-10" y="-30" width="20" height="60" fill="#aaaaaa " opacity="0.8">
          <animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.1s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform>
        </rect>
      </g>
      <g transform="translate(80 50)">
        <rect x="-10" y="-30" width="20" height="60" fill="#aaaaaa " opacity="0.9">
          <animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.2s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform>
        </rect>
      </g>
    </svg>
  </section>
</template>

<script>
import breakpoints from 'utils/breakpoints.js';
import mixins from 'mixins/product-scroller.js';

Component.get('@sweetwater/vue-components/components/currency.vue');
Component.get('components/item.vue');

export default {
  mixins: [mixins],
  props: {
    source: {
      default: '',
      type: String,
    },
    itemjson: {
      default: '',
      type: String,
    },
    itemDetails: {
      type: Object,
      default() {
        return {};
      },
    },
    name: {
      default: '',
      type: String,
    },
    log: {
      default: '',
      type: String,
    },
    minRequired: {
      default: 1,
      type: Number,
    },
    showWhileLoading: {
      default: false,
      type: Boolean,
    },
    boldDeals: {
      default: false,
      type: Boolean,
    },
    showAddToCartButton: {
      default: false,
      type: Boolean,
    },
    showMoreDetailsButton: {
      type: Boolean,
      default: false,
    },
    showFinancing: {
      default: false,
      type: Boolean,
      required: false,
    },
    showSpecials: {
      default: false,
      type: Boolean,
      required: false,
    },
    showProductCallout: {
      default: false,
      type: Boolean,
    },
    showBundleSavings: {
      default: false,
      type: Boolean,
    },
    addToCartButtonText: {
      default: 'Add to Cart',
      type: String,
    },
    showInStockNotice: {
      default: false,
      type: Boolean,
    },
    itemid: {
      default: '',
      type: String,
    },
    itemArray: {
      default() {
        return [];
      },
      type: Array,
    },
    divider: {
      default: true,
      type: Boolean,
    },
    condensed: {
      default: false,
      type: Boolean,
    },
    homepageTrending: {
      default: false,
      type: Boolean,
    },
    paginated: {
      default: true,
      type: Boolean
    },
    oos: {
      default: false,
      type: Boolean,
    },
    showFreeShippingMsg: {
      default: true,
      type: Boolean,
    },
    showCertifiedFitCases: {
      default: true,
      type: Boolean,
      required: false,
    },
    inlinereviewnum: {
      default: true,
      type: Boolean,
      required: false,
    },
    isCategoryFeed: {
      default: true,
      required: false,
      type: Boolean,
    },
    feedIdentifier: {
      default: '',
      required: false,
      type: String,
    },
    showBadgeChips: {
      default: false,
      type: Boolean,
      required: false,
    },
    badgeConfig: {
      type: [String, Object],
      required: false,
      default: '',
    },
    badgeOverrideText: {
      type: String,
      required: false,
      default: '',
    },
    badgeOverrideClass: {
      type: String,
      required: false,
      default: '',
    },
    feedCta: {
      type: [String, Object],
      required: false,
      default: '',
    },
  },
  data() {
    return {
      items: [],
      loadingTimeout: 0,
      loadingTimedOut: false,
      loaded: false,
      specs: [],
      useSpecCompare: false,
    };
  },
  computed: {
    isCondensed() {
      return !this.specs.length || this.windowWidth < breakpoints.small || this.condensed === true;
    },
    isOos() {
      return this.oos === true;
    },
    itemsListTag() {
      return (!this.isCondensed ? 'div' : 'ul');
    },
    loading() {
      return !this.loaded && !this.loadingTimedOut;
    },
    loggingAction() {
      return (this.log ? this.log : `Product Suggest - ${this.name}`);
    },
    parsedFeedCta() {
      if (this.feedCta) {
        let parsedCta = this.feedCta;
        if (typeof this.feedCta === 'string' && this.feedCta.trim() !== '') {
          try {
            parsedCta = JSON.parse(this.feedCta);
          } catch (e) {
            return null;
          }
        }
        if (typeof parsedCta === 'object' && parsedCta.active && parsedCta.text && parsedCta.url) {
          return parsedCta;
        }
      }
      return null;
    },
    similarTitle() {
      let title = 'Also Popular';
      if (this.specs.length && !this.isOos) {
        title = 'Compare to Similar <span class="nowrap">Best Sellers</span>';
      } else {
        title = 'Similar Best Sellers';
      }
      return title;
    },
    sliderHasStarRatings() {
      return this.items.some(item => (item.averageStarRating && item.averageStarRating > 0));
    },
    sliderHasPromos() {
      return this.showSpecials && this.items.some(item => (item.specialOfferTitle));
    },
  },
  watch: {
    loading(current, previous) {
      clearInterval(this.loadingTimeout);
    },
    itemArray() {
      this.setItemsFromArray();
    },
  },
  created() {
    if (Object.keys(this.itemDetails).length !== 0) {
      this.parseItemDetails();
    } else {
      this.addEvents();
      this.fetchAsyncProducts();
      this.parseProductsJson();
      this.setItemsFromArray();
    }
  },
  updated() {
    if (this.items.length) {
      this.load();
    }
    if (this.loaded) {
      if (this.items.length && !this.items[0].badge && this.showBadgeChips) {
        this.addItemBadges();
      }
      this.setLoadComplete();
    }
  },
  methods: {
    colHeaderId(item) {
      return `col-${item.itemid}`;
    },
    rowHeaderId(specIndex) {
      return `row-${specIndex}`;
    },
    columnHeaderLabel(item) {
      const manufacturer = item.manufacturer && (item.manufacturer.name || item.manufacturer);
      return [manufacturer, item.productName].filter(Boolean).join(' ').trim() || '';
    },
    setLoadComplete() {
      if (typeof document !== 'undefined') {
        const productSuggestEls = document.getElementsByClassName('product-suggest');
        if (typeof productSuggestEls !== 'undefined') {
          [...productSuggestEls].forEach(pse => {
            const pseParent = pse.parentElement;
            if (typeof pseParent !== 'undefined') {
              // Give component a chance to fully load on page
              setTimeout(() => {
                pseParent.classList.add('loaded');
              }, 500);
            }
          });
        }
      }
    },
    addEvents() {
      events.$on('productDataUpdate', this.productDataUpdate);
    },
    addToCart(item) {
      this.$emit('addToCart', item);
    },
    itemClicked(item) {
      this.$emit('itemClicked', item);
    },
    /**
     * Async fetch products
     */
    fetchAsyncProducts() {
      if (this.source) {
        this.items = [];
        this.loadingTimeout = setTimeout(() => {
          this.loadingTimedOut = true;
        }, 15000);
        events.$emit('fetch', {name: 'productDataUpdate', url: this.source});
      }
    },

    /**
     * Load from provided JSON, hacking it into the normal update process
     */
    parseProductsJson() {
      if (!this.source && this.itemjson) {
        const data = {};
        data[this.name] = {};
        data[this.name].items = JSON.parse(this.itemjson);
        Vue.nextTick(() => {
          this.productDataUpdate(data);
        });
      }
    },
    parseItemDetails() {
      if (!Object.prototype.hasOwnProperty.call(this.itemDetails, this.name)) {
        return;
      }

      this.loaded = true;
      Object.keys(this.itemDetails[this.name]).forEach((key) => {
        let newValue = this.itemDetails[this.name][key];
        if (key === 'items' && !Array.isArray(newValue)) {
          newValue = Object.values(newValue);
        }
        this[key] = newValue;
      });
    },
    productDataUpdate(data) {
      if (!Object.prototype.hasOwnProperty.call(data, this.name) || this.itemArray.length) {
        return;
      }
      this.loaded = true;
      Object.keys(data[this.name]).forEach((key) => {
        this[key] = data[this.name][key];
      });
    },
    setItemsFromArray() {
      if (this.itemArray) {
        this.items = this.itemArray;
        this.loaded = true;
      }
    },
    comparableCellText(cell) {
      const clone = cell.cloneNode(true);
      clone.querySelectorAll('.visually-hidden').forEach(el => el.remove());
      return clone.textContent.trim();
    },
    highlightDifferences() {
      const tableBody = document.getElementById(`product-suggest-table-${this.itemid}`).querySelector('tbody');
      const checkboxStatus = document.getElementById(`highlightDifferences-${this.itemid}`).checked;

      if (checkboxStatus) {
        for (let j = 0; j < tableBody.rows.length; j++) {
          let row = tableBody.rows[j]
          let currentItem = row.cells[1]

          for (let i = 2; i < row.cells.length; i++) {
            let cell = row.cells[i]

            const normalize = str => str.replace(/[-\s()]/g, '').toLowerCase()
            const currentText = this.comparableCellText(currentItem);
            const cellText = this.comparableCellText(cell);
            if ((normalize(currentText) != normalize(cellText)) & cellText != '-') {
              console.log('highlighting', normalize(currentText), normalize(cellText));
              cell.style.backgroundColor = 'rgba(38, 151, 219, .25)';
              cell.style.outline = '1px solid #a5c8de';
              cell.style.outlineOffset = '-1px';
            }
          };
        }
      } else {
        for (let j = 0; j < tableBody.rows.length; j++) {
          let row = tableBody.rows[j]
          let currentItem = row.cells[1]

          for (let i = 2; i < row.cells.length; i++) {
            let cell = row.cells[i]
            cell.style.backgroundColor = '';
            cell.style.outline = 'none';
          };
        }
      }
    },
    addItemBadges() {
      const badgeConfigObj = typeof this.badgeConfig === 'string' && this.badgeConfig.trim() !== '' ? JSON.parse(this.badgeConfig) : this.badgeConfig;

      const badgeMap = badgeConfigObj && Object.keys(badgeConfigObj).length > 0 ? badgeConfigObj : [];
      if (!badgeMap || Object.keys(badgeMap).length === 0) return;

      this.items.forEach(item => {
        if (item.imageBadge && item.imageBadge !== 'original' && badgeMap[item.imageBadge]) {
          item.badge = badgeMap[item.imageBadge];
        } else {
          item.badge = this.getBadgeFromTitle(item, badgeMap);
        }
      });
    },
    getBadgeFromTitle(item, badgeMap) {
      const emptyBadge = {text: null, class: null};
      const defaultBadge = {text: 'special offer', class: 'badge-red--inverse'};

      if (!item.specialOfferTitle) {
        return emptyBadge;
      }

      const title = item.specialOfferTitle.toLowerCase();
      for (const [key, value] of Object.entries(badgeMap)) {
        if (value.keywords && value.keywords.some(keyword => title.includes(keyword))) {
          return {text: value.text, class: value.class, style: value.style};
        }
      }
      return defaultBadge;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss">
@import '~@sweetwater/sass-resources/sass';

.product-suggest {
  min-height: 410px;
  width: 1450px;
  margin: 0 auto;
  max-width: 100%;
  position: relative;
  text-align: center;

  .loaded & {
    min-height: auto;
  }

  &.collapse {
    display: none;

    +.product-suggest__loader {
      display: none;
    }
  }

  &.product-suggest--tabled {
    background: none;
    border: solid $border-grey;
    border-width: 1px 0;
    padding: 20px 15px 0;
  }

  &__internal {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__name {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &-title {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 80px;
    padding: 0 1rem;
  }

}

.product-suggest__stage {
  position: relative;

  &:has(.product-suggest__table) {
    padding-bottom: 3rem;

    @include media('<small') {
      padding: 0 1rem;
    }
  }
}

.product-suggest__item-wrap {
  display: inline-block;
  position: relative;
  vertical-align: top;
  border: 1px solid var(--neutral100);
  border-radius: 0.75rem;
  max-width: 450px;
  padding: 0.5rem 0 1.5rem;

  @include media('<small') {
    padding: 0.5rem 0.125rem 1.25rem;
  }

  .flexbox & {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: inherit;

    &.product-suggest__item-wrap-cols {
      flex-direction: column;
      justify-content: space-between;
    }
  }

  &:hover .btn.view-more-details {
    opacity: 1;
  }

  &:hover .product-suggest__internal {
    display: block;
  }

  &:hover,
  &:focus-within {
    border-color: var(--neutral200);
    box-shadow: 0 4px 6px -2px rgba(var(--black-rgb-raw), .1), 0 12px 16px -4px rgba(var(--black-rgb-raw), .1);
    z-index: 1;

    .product-suggest__item-image {
      transform: scale(1.05);
    }
  }
}

li.product-suggest__item-wrap-cols {
  justify-content: space-between;
  margin-top: 3px;
}

#store-detail .product-suggest h2,
#store-detail .product-suggest .t-h2 {
  padding: 1em 0.5em;
}

.highlightDifferencesLabel {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  color: $dark-grey;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.5;
  padding-left: 1.5rem;
  text-align: left;
  text-indent: -1.5rem;

  @include media('<=medium') {
    font-size: 0.875rem;
  }

  @include media('<=small') {
    left: 0.75rem;
  }
}

.highlightDiffCheckbox {
  height: 1rem;
  width: 1rem;
  display: inline-block;
  margin-right: 0.25rem;
  vertical-align: -0.125rem;
}

.checkboxContainer {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.product-summary .product-suggest {
  flex: 1;
  margin: -1px -16px 0;
  min-width: 100%;
  position: relative;
  width: auto;
  z-index: 1;

  @include media('>=small') {
    margin: -1px -25px 0;
  }
}

.product-suggest__disc-cat-link {
  font-size: 18px;
  font-weight: 600;

  a {
    text-decoration: none;
  }

  .product .product-suggest & svg {
    fill: currentColor;
    height: 12px;
    width: 12px;
  }
}

/* Headline */
.product-suggest h2,
.product-suggest .t-h2 {
  font-size: 24px;
  font-weight: 600;
}

/* Items */
.product-suggest__items {
  box-sizing: border-box;
  font-size: 10px;
  gap: 0.25rem;
  margin: 0;
  max-width: 100%;
  min-height: 200px;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 1rem;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: auto;

  @include media('>=small') {
    font-size: 12px;
    min-height: 260px;

    #manufacturer-page-product-suggestions & {
      min-height: initial;
    }
  }

  .flexbox & {
    display: inline-flex;
    flex-direction: row;
    white-space: normal;
  }
}

.pdp-recommends .product-suggest__items {
  overflow-x: hidden;
}

.product-suggest_bundle-savings {
  /* stylelint-disable-line selector-class-pattern */
  color: #d54140;
  font-size: 1.3em;
  font-weight: 700;
}

.product-suggest--tabled .product-suggest__items {
  padding-bottom: 0;
}

.product-suggest__item {
  color: inherit;
  display: inline-block;
  text-decoration: none;
  vertical-align: top;
  white-space: normal;
  margin: 0 8px;
  padding: 8px 8px 0;
  width: 260px;

  @include media('<large') {
    width: 220px;
  }

  @include media('<small') {
    padding: 8px 4px 0;
    width: 200px;
  }

  @include media('<xsmall') {
    width: 180px;
  }

  &,
  &:active {
    background: #fff;
  }

  .flexbox & {
    display: block;
    flex: none;
  }

  .product-suggest__item-instock {
    color: shade($green, 10%);
    display: block;
    font-size: 1.5em;
    font-weight: 600;
    margin-bottom: 15px;

    svg {
      display: inline-block;
      fill: currentColor;
      height: 25px;
      margin-top: -3px;
      vertical-align: middle;
      width: 25px;
    }
  }
}

a.product-suggest__item {
  color: inherit;
  outline-offset: -4px; // Safari

  &:focus-visible {
    outline-offset: -2px; // GOOD browsers
  }
}

.product-suggest__item-imgwrap {
  margin: 3px auto 15px;
  position: relative;
  height: 240px;
  max-width: 100%;
  padding: 1.25rem;
  width: 240px;

  @include media('<large') {
    height: 200px;
    padding: 0.25rem;
    width: 200px;
  }

  @include media('<small') {
    height: auto;
    padding: 0;
    width: 180px;
  }

  @include media('<xsmall') {
    margin: 0 auto;
    width: 160px;
  }

  img.product-suggest__item-image {
    border: 0;
    height: auto;
    image-rendering: auto;
    width: 100%;
  }

  .product-suggest__table & {
    height: 120px;
    width: 120px;
  }
}

.product-suggest__item-image--placeholder {
  fill: var(--neutral100);
  height: 100%;
  width: 100%;
}

.product-suggest__item-imgbadge {
  height: auto;
  left: 0;
  position: absolute;
  top: 0;
  width: 80%;
}

.product-suggest__item-badge {
  --foreground: var(--white);
  --background: var(--black);
  --border: var(--background);
  background: var(--background);
  border: 1px solid var(--border);
  border-radius: 4px;
  color: var(--foreground);
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  left: -0.35rem;
  line-height: 1;
  max-width: 85%;
  opacity: 0.9;
  padding: 0.5rem 0.5rem 0.4rem;
  position: absolute;
  text-transform: uppercase;
  transition: opacity 0.5s ease-in-out;
  top: -0.05rem;
  z-index: 10;

  @include media('<small') {
    top: 0rem;
  }

  &.badge-aqua {
    --background: var(--aqua800);

    &--inverse {
      --background: var(--white);
      --foreground: var(--aqua800);
      --border: var(--foreground);
    }
  }

  &.badge-blue {
    --background: var(--blue);

    &--inverse {
      --background: var(--white);
      --foreground: var(--blue);
      --border: var(--foreground);
    }
  }

  &.badge-dark-blue {
    --background: var(--blue700);

    &--inverse {
      --background: var(--white);
      --foreground: var(--blue700);
      --border: var(--foreground);
    }
  }

  &.badge-green {
    --background: var(--green);

    &--inverse {
      --background: var(--white);
      --foreground: var(--green);
      --border: var(--foreground);
    }
  }

  &.badge-grey,
  &.badge-gray {
    --background: var(--neutral50);
    --foreground: var(--black);
    --border: var(--foreground);

    &--inverse {
      --background: var(--black);
      --foreground: var(--neutral50);
    }
  }

  &.badge-orange {
    --background: var(--orange700);

    &--inverse {
      --background: var(--white);
      --foreground: var(--orange700);
      --border: var(--foreground);
    }
  }

  &.badge-pink {
    --background: var(--pink700);

    &--inverse {
      --background: var(--white);
      --foreground: var(--pink700);
      --border: var(--foreground);
    }
  }

  &.badge-purple {
    --background: var(--purple);

    &--inverse {
      --background: var(--white);
      --foreground: var(--purple);
      --border: var(--foreground);
    }
  }

  &.badge-red {
    --background: var(--red);

    &--inverse {
      --background: var(--white);
      --foreground: var(--red);
      --border: var(--foreground);
    }
  }

  &.badge-dark-red {
    --background: var(--red700);

    &--inverse {
      --background: var(--white);
      --foreground: var(--red700);
      --border: var(--foreground);
    }
  }

  &.badge-white {
    --background: var(--white);
    --foreground: var(--black);
    --border: var(--neutral400);
  }

  &.badge-yellow {
    --background: var(--yellow);
    --foreground: var(--black);
    --border: var(--background);

    &--inverse {
      --background: var(--white);
      --foreground: var(--yellow700);
      --border: var(--foreground);
    }
  }

  span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.product-suggest__divider {
  border-top: 1px solid #333;

  height: 5px;
}

.product-suggest__item-current {
  font-weight: 800;
  padding-bottom: 4px;
  z-index: 50;
  background-color: #ffffffd1;
}

.product-suggest__item-deal-text {
  color: $blue;
  font: 800 1.333em/1.1 $font-stack-condensed;
  margin-bottom: 3px;
}

.deals-bold .product-suggest__item-deal-text,
.product-suggest__item-callout {
  background: $red;
  color: #fff;
  font: 600 1.11111em/1.1 $font-stack-condensed;
  line-height: 1;
  margin-bottom: 3px;
  padding: 3px 5px;
}

.product-suggest__item p {
  color: inherit;
  font-weight: 400;
  margin-bottom: 3px;
  margin-top: 0;
}

.product-suggest__table .product-suggest__item p {
  @include media('<small') {
    font-size: 14px;
  }
}

.product-suggest__table tr a.compare-link-wrap {
  text-decoration: none;
  color: inherit;
  display: table-cell; 
  height: stretch;
  position: relative;
  width: 160px;

  @include media('<small') {
    width: 140px;
  }

  @include media('<=xsmall') {
    width: 44vw;
  }
  th {
    height: 100%;
    width: 100%;
    display: block;
  }
  .visually-hidden {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%; 
  }
}

.product-suggest__item-price {
  line-height: 1;
  margin: 0.5rem 0;
  color: var(--black);
  font-size: 1.25rem;
  font-weight: 700;
  order: 2;
  text-align: left;

  @include media('<xsmall') {
    font-size: 1.125rem;
  }

  &.has-special-offer {
    price {
      color: var(--red);
    }

    del price {
      color: var(--neutral600);
    }
  }

  del {
    color: var(--neutral600);
    font-size: 0.75rem;
    font-weight: 400;
    margin-right: 0.25rem;

    price {
      color: var(--neutral600);
    }
  }
}

.product-suggest__item-shipping {
  display: none;
}

.product-suggest__item .rating__stars {
  margin-bottom: 4px;
}

.product-suggest__item-review-count {
  color: tint($dark-grey, 30%);
  display: block;
}

.product-suggest__item-review-count-inline {
  display: inline-block;
  vertical-align: -2px;

  @extend .product-suggest__item-review-count;
  display: inline;
  font-size: 14px;
}

/* Table */
.product-suggest__table {
  background: #fff;
  border-spacing: 0;
  border-collapse: collapse;
  margin: 0 auto;
  table-layout: fixed;
  white-space: normal;
  width: 100%;
  height: fit-content;

  tr,
  td,
  th {
    height: 100%;
  }

  +li {
    list-style: none;
  }
}

.product-suggest__table th,
.product-suggest__table td {
  border-radius: 0;
  hyphens: auto;
  overflow-wrap: break-word;
  padding: 0;
  text-align: center;
  vertical-align: top;
  width: 160px;

  @include media('<small') {
    vertical-align: middle;
    width: 140px;
  }

  @include media('<=xsmall') {
    width: 44vw;
  }
}

.product-suggest__table thead td {
  &:first-of-type {
    width: 160px;
  }

  @include media('<small') {
    &:first-of-type {
      background: #fff;
      left: -1px;
      position: sticky;
      width: 120px;
      z-index: 51;
    }
  }
}

/* Table Item */
.product-suggest__table .product-suggest__item {
  margin: 0 auto;
  width: 100%;

  @include media('<small') {
    font-size: 14px;
    padding: 15px 0 0;
  }
}


@media (max-width: 767px) {
  #product-suggest-similar-wrap .paged.product-suggest__items {
    padding: 0px 0px 10px;
  }
}

.product-suggest__table {

  .product-suggest__item-content {
    padding: 0 6px;
  }

  .product-suggest__item-wrap {
    padding-bottom: 0;
    border-radius: 0;
  }

  .product-suggest__item-name {
    font-size: 14px;
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }

  p.product-suggest__item-name strong {
    font-size: 14px;
  }

  .product-suggest__item-price {
    font-size: 18px;
    margin: 0;
  }

  .product-suggest__item-current {
    position: absolute;
    justify-self: center;
  }

  .product-suggest__item-imgwrap {
    margin: 4px auto;
  }

  .product-suggest__item-image {
    margin-top: 0;
  }

  .product-suggest__item-reviews {
    margin: 0.25rem 0 0.75rem -0.25rem;
  }

  .star__ratings--md[data-rating] i {
    height: 1.2rem;
    width: 1.2rem;
  }
}

/* Table Body */
.product-suggest__table tbody {
  font-size: 12px;

  @include media('>=medium') {
    font-size: 14px;
  }

  // @include media('<small') {
  //     display: none;
  // }
}

.product-suggest__table tbody th {
  background: tint($light-grey, 30%);
  font-weight: 600;
  text-align: left;

  @include media('<small') {
    left: -1px;
    position: sticky;
    z-index: 1;
  }
}

.product-suggest__table tbody th,
.product-suggest__table tbody td {
  border: solid $border-grey;
  border-width: 1px;
  hyphens: auto;
  overflow-wrap: break-word;
  padding: 5px 15px;
}

.product-suggest__table tbody .current {
  background: tint($yellow, 50%);
  border-color: shade($yellow, 7%);
}

.product-suggest__table tbody tr:hover th,
.product-suggest__table tbody tr:hover td {
  background: tint($blue, 87%);
  border-color: tint($blue, 60%);
  box-shadow: 0 1px 0 tint($blue, 60%);

  @include media('>=small') {
    position: relative;
    z-index: 2;
  }
}

.product-suggest__table tbody tr:hover th {
  background: tint($blue, 80%);
}

// Nav
$product-suggest-nav-background: tint($light-grey, 30%);

.product-suggest__nav {
  background: linear-gradient(to right, #fff 80%, rgba(255, 255, 255, 0));
  cursor: pointer;
  display: none;
  font-size: 0;
  height: calc(100% - 1.125rem);
  overflow: hidden;
  position: absolute;
  text-indent: -9999px;
  top: 0;
  transition: all 0.15s ease;
  transition-property: background, opacity;
  width: 80px;
  z-index: 10;

  svg {
    height: 40px;
    left: 50%;
    opacity: 0.6;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -60%);
    width: 40px;
  }

  &:hover svg {
    opacity: 1;
  }

  &.disabled,
  &.disabled:hover {
    cursor: default;

    svg {
      opacity: 0.15;
    }
  }
}

.product-suggest__nav--prev {
  left: 0px;
}

.product-suggest__nav--next {
  background: linear-gradient(to left, #fff 80%, rgba(255, 255, 255, 0));
  left: auto;
  right: 0px;
}

.product-suggest__item-certfit {
  left: -25px;
  position: absolute;
  top: 0;
  width: 45px;

  @include media('<small') {
    left: 0;
    width: 30px;
  }

  img {
    height: auto;
    width: 100%;
  }
}

@include media('>=small') {

  .paged.product-suggest__items {
    gap: 0.5rem;
    padding: 0 0 1rem 80px;
  }

  .pdp-recommends .paged.product-suggest__items {
    padding: 0;
  }

  .product-suggest__nav.visible {
    display: block;
  }

  .paged li:last-of-type,
  .paged .product-suggest__table {
    margin-right: 80px;
  }
}

@include media('<small') {
  .paged.product-suggest__items {
    padding: 0 10px 10px;
  }
}

.product-suggest__long-description {
  color: #222;
  font-size: 12px;
  margin-top: 1em;
  text-align: left;

  b {
    display: block;
    padding-top: 1em;
    text-align: center;
  }
}



.product-suggest__wide-image {
  left: -23px;
  position: relative;
  top: -23px;
  width: calc(100% + 43px);
}

#product-suggest-certifiedFits {
  h2::before {
    border: 3px solid #3b7d1a;
    border-left: 0;
    border-top: 0;
    content: '';
    display: inline-block;
    height: .8em;
    transform: rotate(45deg) translate(-0.3em, 0.25em);
    width: 0.4em;
  }

  h5 {
    padding: 0.5em 0 1em 0;
  }
}

@media screen and (max-width: 512px) {
  #product-suggest-certifiedFits h5 {
    font-size: .85rem;
  }
}

#suggested-products,
#suggested-cases,
#suggested-accessories {
  border-bottom: 1px solid $light-grey;
  border-top: 1px solid $light-grey;
}

.item-upsell {

  &__freeitem {
    display: flex;
    align-items: start;
    padding-top: 1em;
    font-size: 10px;

    a:link,
    a:visited {
      color: #222;
      text-decoration: none;
    }

    &-title {
      color: #d71920
    }

    div {
      display: flex;
      flex-direction: column;
      width: 100%;

      &:not(.item-upsell__freeitem-content) {
        max-width: calc(100% - 3.5rem);
      }
    }

    &-content {
      div {
        flex-direction: row;
        flex-wrap: wrap;
        width: 100% !important;
        max-width: unset !important;
      }
    }
  }

  &__freeitem-image {
    height: 50px;
    width: 50px;
    object-fit: contain;
    margin-right: 10px;
    filter: brightness(0.95);
    background-color: #fff;
    border-radius: 4px;
  }

}

p.item-upsell__freeitem-title {
  color: #d71920;
}

p.item-upsell__freeitem-title {
  margin: 0;
}

.product-suggest-algolia {
  max-width: 1770px;
  width: 100%;

  &:has(.ais-Hits)+.product-suggest__loader {
    display: none;
  }
}

.content--wrapper .product-suggest__loader {
  height: 660px;
  margin: 0 auto;
  max-width: 1620px;
  width: 100%;

  @include media('<large') {
    height: 620px;
  }

  @include media('<small') {
    height: 600px;
  }

  @include media('<small') {
    height: 544px;
  }
}

.product-suggest__loader-items {
  background: linear-gradient(90deg, #fff 6px, var(--neutral50) 0, var(--neutral50) 240px, #fff 0);
  background-repeat: repeat;
  background-size: 245px;
  height: 555px;

  @include media('<large') {
    background-size: 220px;
    height: 534px;
  }

  @include media('<small') {
    background-size: 200px;
    height: 512px;
  }

  @include media('<xsmall') {
    background-size: 180px;
    height: 460px;
  }

  &::before {
    background: linear-gradient(90deg, #fff 6px, var(--neutral50) 0, var(--neutral50) 80px, #fff 0, #fff 215px);
    background-repeat: repeat;
    background-size: 245px;
    border-top: 10px solid #fff;
    height: 20px;

    @include media('<large') {
      background-size: 220px;
    }

    @include media('<small') {
      background-size: 200px;
    }

    @include media('<xsmall') {
      background-size: 180px;
    }
  }
}

.product-suggest__item {
  &-image {
    margin-top: 0.5rem;
    transition: transform 0.1s ease-in-out;
  }
}

.product-suggest__item-content {
  display: flex;
  flex-flow: column;
  gap: 0.25rem;
  margin-bottom: 0.25rem;

  @include media('<xsmall') {
    gap: 0;
  }
}

.product-suggest__item-reviews {
  margin: 0 0 0.5rem;
  text-align: left;
  order: 3;


  @at-root .cf__column & {
    margin: 0 0 0.75rem;
    order: unset;
    text-align: center;
  }

  .rating__stars--small i {
    height: 19px;
    width: 20px;
  }
}

.product-suggest__rebates {
  order: 5;
}

.product-suggest__financing {
  order: 6;
}

p.product-suggest__item-name {
  -webkit-box-orient: vertical;
  font-size: 1rem;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  line-height: 1.25;
  margin: 0.5rem 0 0.25rem;
  order: 1;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;

  @include media('<xsmall') {
    font-size: 0.875rem;
  }

  strong {
    color: var(--neutral600);
    display: block;
    font-size: 0.875rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }
}

.product-suggest__button-wrap {
  justify-content: center;

  &.slider-cta {
    margin: 2rem auto 1rem;

    a.btn.cta-btn {
      font-size: 1rem;
      height: auto;
      min-width: 300px;
      padding: 1rem 2.75rem;
      width: auto;
    }
  }
}

.btn.add-to-cart,
.btn.cta-btn {
  align-items: center;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  border: 2px solid var(--black);
  border-radius: 4rem;
  box-sizing: border-box;
  color: var(--black);
  cursor: pointer;
  display: flex;
  flex-flow: column;
  font-size: 0.875rem;
  font-weight: 600;
  height: 2.5rem;
  justify-content: center;
  line-height: 1;
  margin: 0;
  max-width: calc(100% - 2rem);
  outline-offset: 0.25rem;
  width: 100%;

  &:hover,
  &:focus {
    background: var(--black);
    color: var(--white);
  }
}
</style>
